// @flow

// Types
import type { AssetMigrateOperation } from '../../types'

// Operator
import operator from '../operator'

// Effect Managers
import { call, fork, put, race, select, take } from 'redux-saga/effects'

type OperationsArgs = {
  operations$: (state: Object) => Array<AssetMigrateOperation>
}

export default function *watchOperations ({operations$}: OperationsArgs): Generator<*, void, *> {
  while (true) {
    yield take([operator.actionTypes.add(), operator.actionTypes.edit(), operator.actionTypes.delete()])
    yield fork(handleOperations, {operations$})
  }
}

export function *handleOperations ({ operations$ }: OperationsArgs): Generator<*, void, *> {
  let done = false

  while (!done) {
    const effect = yield race({
      submit: take(operator.actionTypes.submitOperations()),
      cancel: take(operator.actionTypes.cancelOperations()),
    })

    if (effect.submit) {
      return
    } else {
      done = yield call(handleCancelOperations, { operations$ })
    }
  }
}

export function *handleCancelOperations ({ operations$ }: OperationsArgs): Generator<*, boolean, *> {
  const operations = yield select(operations$)
  const action = yield operator.actionCreators.cancelOperations(operations)
  yield put(action)
  return true
}

